import { render, staticRenderFns } from "./excellentvideo.vue?vue&type=template&id=2d913c24&scoped=true&"
import script from "./excellentvideo.vue?vue&type=script&lang=js&"
export * from "./excellentvideo.vue?vue&type=script&lang=js&"
import style0 from "./excellentvideo.vue?vue&type=style&index=0&id=2d913c24&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d913c24",
  null
  
)

export default component.exports